// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

export default {
  bind: function bind(el) {
    var dragDom = el.querySelector('.el-dialog');
    var lineEl = document.createElement('div');
    lineEl.style = 'width: 6px; background: inherit; height: 10px; position: absolute; right: 0; bottom: 0; margin: auto; z-index: 1; cursor: nwse-resize;';
    lineEl.addEventListener('mousedown', function (e) {
      // 鼠标按下，计算当前元素距离可视区的距离
      var disX = e.clientX - el.offsetLeft;
      var disY = e.clientY - el.offsetTop;
      // 当前宽度 高度
      var curWidth = dragDom.offsetWidth;
      var curHeight = dragDom.offsetHeight;
      document.onmousemove = function (e) {
        e.preventDefault(); // 移动时禁用默认事件
        // 通过事件委托，计算移动的距离
        var xl = e.clientX - disX;
        var yl = e.clientY - disY;
        dragDom.style.width = "".concat(curWidth + xl, "px");
        dragDom.style.height = "".concat(curHeight + yl, "px");
      };
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }, {
      passive: true
    });
    dragDom.appendChild(lineEl);
  }
};